module.exports = __webpack_public_path__ + "img/MountedPolice.0a6be15d.png";